<template>
  <div class="container-fluid p-4">
    <DetailTop v-if="loadedTop && detailTop" :detailTop="detailTop" />
    <div v-if="loadedTop" class="d-flex flex-between my-3">
      <h4 class="text-uppercase mb-0">data Pasien</h4>
    </div>
    <div class="row" v-if="loadedTop">
      <div class="col-md-8 pr-1">
        <DetailLeft
          v-if="loadedTop && detailLeftTop"
          :detailLeftTop="detailLeftTop"
        />
      </div>
      <div class="col-md-4 pl-1">
        <DetailRight
          v-if="loadedTop && detailRightTop"
          :detailRightTop="detailRightTop"
        />
      </div>
    </div>
    <Loading v-else />
    <div class="d-flex flex-between my-3">
      <h4 class="text-uppercase mb-0">rekam medis pasien</h4>
      <button
        @click="print"
        class="btn btn-with-icon-left btn-secondary text-uppercase"
      >
        <i class="material-symbols-outlined">print</i>
        cetak riwayat kontrol
      </button>
    </div>
    <div class="no-print">
      <div class="row mb-3">
        <div class="col-md-12">
          <!-- @include('blocks.tabs') -->
          <ul class="nav nav-pills page-header-tab">
            <!-- @each(item in tabs) -->
            <li
              v-for="item in tabs"
              v-bind:key="item.title + String(Math.random(1023))"
              :class="'nav-item'"
            >
              <button
                :class="'nav-link tab-filter ' + (item.active ? 'active' : '')"
                @click="() => activateTab(item)"
              >
                {{ item.title }}
              </button>
            </li>
            <!-- @endeach -->
          </ul>
        </div>
      </div>
    </div>
    <div class="print" v-show="tabActive == 'ralan'">
      <h5 class="mt-4 text-uppercase">Riwayat Rawat Jalan</h5>
      <TableResponsive
        v-if="loaded && rows1.length"
        :filter="filter1"
        :rows="rows1"
        :columns="columns1"
        :page="page1"
        :perPage="perPage1"
      />
      <EmptyState
        v-else-if="loaded && !rows1.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat rawat jalan di sini',
          content: 'Pasien belum memiliki rekam medis berupa rawat jalan',
        }"
      />
      <Loading v-else />
    </div>
    <div class="print" v-show="tabActive == 'ranap'">
      <h5 class="mt-4 text-uppercase">Riwayat Rawat Inap</h5>
      <TableResponsive
        v-if="loaded && rows2.length"
        :filter="filter2"
        :rows="rows2"
        :columns="columns2"
        :page="page2"
        :perPage="perPage2"
      />
      <EmptyState
        v-else-if="loaded && !rows2.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat rawat inap di sini',
          content: 'Pasien belum memiliki rekam medis berupa rawat inap',
        }"
      />
      <Loading v-else />
    </div>
    <div class="print" v-show="tabActive == 'obat'">
      <h5 class="mt-4 text-uppercase">Riwayat Tebus Obat / Alkes</h5>
      <TableResponsive
        v-if="loaded && rows3.length"
        :filter="filter3"
        :rows="rows3"
        :columns="columns3"
        :page="page3"
        :perPage="perPage3"
      />
      <EmptyState
        v-else-if="loaded && !rows3.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat tebus obat di sini',
          content: 'Pasien belum pernah menebus obat',
        }"
      />
      <Loading v-else />
    </div>
    <div class="print" v-show="tabActive == 'optik'">
      <h5 class="mt-4 text-uppercase">Riwayat Tebus Optik</h5>
      <TableResponsive
        v-if="loaded && rows4.length"
        :filter="filter4"
        :rows="rows4"
        :columns="columns4"
        :page="page4"
        :perPage="perPage4"
      />
      <EmptyState
        v-else-if="loaded && !rows4.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat tebus optik di sini',
          content: 'Pasien belum pernah menebus barang optik',
        }"
      />
      <Loading v-else />
    </div>
    <div class="print" v-show="tabActive == 'lab'">
      <h5 class="mt-4 text-uppercase">Riwayat Pemeriksaan Lab</h5>
      <TableResponsive
        v-if="loaded && rows5.length"
        :filter="filter5"
        :rows="rows5"
        :columns="columns5"
        :page="page5"
        :perPage="perPage5"
      />
      <EmptyState
        v-else-if="loaded && !rows5.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat periksa lab di sini',
          content: 'Pasien belum melakukan pemeriksaan lab',
        }"
      />
      <Loading v-else />
    </div>
    <div class="print" v-show="tabActive == 'operasi'">
      <h5 class="mt-4 text-uppercase">Riwayat Operasi</h5>
      <TableResponsive
        v-if="loaded && rows6.length"
        :filter="filter6"
        :rows="rows6"
        :columns="columns6"
        :page="page6"
        :perPage="perPage6"
      />
      <EmptyState
        v-else-if="loaded && !rows6.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat operasi di sini',
          content: 'Pasien belum memiliki rekam medis berupa operasi',
        }"
      />
      <Loading v-else />
    </div>
    <div class="print" v-show="tabActive == 'ugd'">
      <h5 class="mt-4 text-uppercase">Riwayat UGD</h5>
      <TableResponsive
        v-if="loaded && rows7.length"
        :filter="filter7"
        :rows="rows7"
        :columns="columns7"
        :page="page7"
        :perPage="perPage7"
      />
      <EmptyState
        v-else-if="loaded && !rows7.length"
        :data="{
          size: 'small',
          title: 'Belum ada riwayat rawat darurat di sini',
          content: 'Pasien belum memiliki rekam medis berupa rawat darurat',
        }"
      />
      <Loading v-else />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import TableResponsive from "@/components/TableResponsive.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
// import { HTTP } from "@/config.js";
import { setPatientIntro } from "@/data/helper.js";
let tabs = [
  { title: "rawat jalan", link: "ralan", active: true },
  { title: "rawat inap", link: "ranap" },
  { title: "rawat darurat", link: "ugd" },
  { title: "tebus obat", link: "obat" },
  { title: "tebus optik", link: "optik" },
  { title: "periksa lab", link: "lab" },
  { title: "operasi", link: "operasi" },
];
let data = {
  title: "Detail Pasien",
  backBtn: "/pasien",
  actionBtn: [],
  breadcrumb: [
    { title: "Pasien", link: "/pasien" },
    { title: "Detail Pasien", active: true },
  ],
};

let columns1 = [
  { label: "No Reg", field: "no_reg" },
  { label: "No Rawat", field: "no_rawat" },
  { label: "Tanggal", field: "formatted_tgl_periksa" },
  { label: "Jam", field: "formatted_jam_periksa" },
  { label: "Dokter", field: "dokter.formatted_nama" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/ralan/detail/${item.id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
  // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
];

let columns2 = [
  { label: "No Rawat", field: "no_rawat" },
  { label: "Masuk Pada", field: "masuk" },
  { label: "Keluar Pada", field: "keluar" },
  { label: "Kamar", field: "kamar_ranap.nama" },
  { label: "Nomor Kasur", field: "kamar_ranap.no_kasur" },
  { label: "Kelas", field: "kamar_ranap.kelas" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/ranap/detail/${item.id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
];
let columns3 = [
  { label: "No Rawat", field: "no_rawat" },
  { label: "Tebus Obat", field: "rln_obat_list" },
  { label: "Total Harga", field: "tagihan_ringkasan_total_bayar" },
  { label: "Status", field: "tagihan_ringkasan_status" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/apotik/detail/${item.ralan_id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
];

let columns4 = [
  { label: "No Rawat", field: "no_rawat" },
  { label: "Tebus Resep Optik", field: "rln_optik_list" },
  { label: "Total Harga", field: "tagihan_ringkasan_total_bayar" },
  { label: "Status", field: "tagihan_ringkasan_status" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/optik/detail/${item.ralan_id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
];

let columns7 = [
  { label: "No Reg", field: "no_reg" },
  { label: "No Rawat", field: "no_rawat" },
  { label: "Tanggal", field: "formatted_tgl_periksa" },
  { label: "Jam", field: "formatted_jam_periksa" },
  { label: "Dokter", field: "dokter.formatted_nama" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/ugd/detail/${item.id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
];

let columns5 = [
  { label: "No Rawat", field: "no_rawat" },
  { label: "Pemeriksaan Lab", field: "periksa_lab_list" },
  { label: "Total Harga", field: "tagihan_ringkasan_total_bayar" },
  { label: "Status", field: "tagihan_ringkasan_status" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/lab/form/${item.ralan_id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
];

let columns6 = [
  { label: "No Rawat", field: "ralan.no_rawat" },
  {
    label: "Jadwal Operasi",
    representedAs: (item) => `${item.tanggal} | ${item.sign_in}`,
  },
  { label: "kategori", field: "kategori_tindakan" },
  { label: "Golongan", field: "golongan_tindakan" },
  { label: "Operasi", field: "nama_operasi" },
  {
    label: "",
    class: "dropdown",
    representedAs: (item) =>
      `<a class="btn btn-sm btn-success btn-icon" href="/#/operasi/detail/${item.id_ralan}/${item.id}"><i class="material-symbols-outlined">open_in_new</i></a>`,
    interpolate: true,
  },
];

export default {
  name: "PasienCetakRiwayatKontrol",
  components: {
    DetailTop,
    DetailLeft,
    DetailRight,
    TableResponsive,
    Loading,
    EmptyState,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded: false,
      loadedTop: false,
      test: "hahaha",
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      tabs: tabs,
      tabActive: "ralan",
      filter1: "",
      page1: 1,
      perPage1: 10,
      columns1: columns1,
      rows1: [],
      filter2: "",
      page2: 1,
      perPage2: 10,
      columns2: columns2,
      rows2: [],
      filter3: "",
      page3: 1,
      perPage3: 10,
      columns3: columns3,
      rows3: [],
      filter4: "",
      page4: 1,
      perPage4: 10,
      columns4: columns4,
      rows4: [],
      filter5: "",
      page5: 1,
      perPage5: 10,
      columns5: columns5,
      rows5: [],
      filter6: "",
      page6: 1,
      perPage6: 10,
      columns6: columns6,
      rows6: [],
      filter7: "",
      page7: 1,
      perPage7: 10,
      columns7: columns7,
      rows7: [],
      pasien: {},
      nDisplay: 7,
    };
  },
  methods: {
    activateTab(tab) {
      this.tabActive = tab.link;
      this.tabs = this.tabs.map((item) => {
        if (item.active) {
          item.active = false;
        }
        if (tab.link == item.link) {
          item.active = true;
        }
        return item;
      });
    },
    displayData: async function() {
      this.loadedTop = false;
      this.loaded = false;
      this.errors = [];
      this.nDisplay = 7;
      try {
        let result = await this.$store.state.HTTP.get(
          `pasien/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.pasien = result.data;
          this.detailTop = setPatientIntro(this.pasien);
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                { label: "data diri pasien", labelClass: "text-primary" },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "No Rekam Medis",
                  content: this.pasien.no_rm,
                  icon: "apps",
                },
                {
                  label: "Nama Pasien",
                  content: this.pasien.nama,
                  icon: "apps",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "jenis kelamin",
                  content: this.pasien.jen_kelamin,
                  icon: "apps",
                },
                {
                  label: "golongan darah",
                  content: this.pasien.gol_darah,
                  icon: "apps",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "tempat, tanggal lahir",
                  content: this.pasien.formatted_tempat_tgl_lahir,
                  icon: "apps",
                },
                {
                  label: "Nomor " + this.pasien.jenis_id,
                  content: this.pasien.no_id,
                  icon: "apps",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Pendidikan Terakhir",
                  content: this.pasien.pendidikan,
                  icon: "apps",
                },
                {
                  label: "nama ibu kandung",
                  content: this.pasien.nama_ibu,
                  icon: "apps",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                { label: "agama", content: this.pasien.agama, icon: "apps" },
                {
                  label: "status nikah",
                  content: this.pasien.status_nikah,
                  icon: "apps",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "nomor telepon",
                  content: this.pasien.no_telp,
                  icon: "apps",
                },
                {
                  label: "pekerjaan",
                  content: this.pasien.pekerjaan,
                  icon: "apps",
                },
              ],
            },
            //   {
            //     key: String(Math.random(1023)),
            //     colnum: 1,
            //     columns: [{ label: "Nomor KTP", content: "18020618900001", icon: "apps" }]
            //   },
            {
              key: String(Math.random(1023)),
              colnum: 1,
              columns: [
                {
                  label: "Alamat",
                  content: this.pasien.alamat,
                },
              ],
            },
            //   {
            //     key: String(Math.random(1023)),
            //     colnum: 1,
            //     columns: [{ label: "", content: "", icon: "apps" }]
            //   }
          ];
          this.detailRightTop = [
            { label: "DATA PENANGGUNG JAWAB", labelClass: "text-primary" },
            {
              label: "Penanggung Jawab",
              content: this.pasien.formatted_pj,
              icon: "apps",
            },
            {
              label: "Pekerjaan",
              content: this.pasien.pj_pekerjaan,
              icon: "apps",
            },
            {
              label: "Alamat",
              content: this.pasien.pj_alamat,
              icon: "place",
            },
            { label: "DATA PEMBAYARAN", labelClass: "text-primary" },
            {
              label: "Metode Pembayaran",
              content: this.pasien.asuransi.nama,
              icon: "payment",
            },
            {
              label: "Nomor Peserta",
              content: this.pasien.no_peserta,
              icon: "contacts",
            },
          ];
          this.loadedTop = true;
          this.displayRalan(this.pasien.no_rm);
          this.displayRanap(this.pasien.no_rm);
          this.displayObat(this.pasien.no_rm);
          this.displayOptik(this.pasien.no_rm);
          this.displayLab(this.pasien.no_rm);
          this.displayOperasi(this.pasien.no_rm);
          this.displayUgd(this.pasien.no_rm);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayRalan: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        let params = `?per_page=999999999999&darurat=0&no_rm=${no_rm}`;
        let result = await this.$store.state.HTTP.get(`ralan${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows1 = result.data.data.filter((item) => {
            return item.no_rm == no_rm;
          });
          //console.log(this.rows1)
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
        this.print();
      }
    },
    displayRanap: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        let params = `?per_page=999999999999&no_rm=${no_rm}`;
        let result = await this.$store.state.HTTP.get(`ranap${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows2 = result.data.data.filter((item) => {
            return item.no_rm == no_rm;
          });
          this.rows2 = this.rows2.map((item) => {
            item.masuk =
              item.formatted_tgl_masuk + " " + item.formatted_jam_masuk;
            item.keluar =
              item.formatted_tgl_keluar + " " + item.formatted_jam_keluar;
            return item;
          });
          //console.log(this.rows2)
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
        this.print();
      }
    },
    displayObat: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        let params = `?per_page=999999999999&no_rm=${no_rm}&orderBy=desc`;
        let result = await this.$store.state.HTTP.get(`menu/apotik${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows3 = result.data.filter((item) => {
            return no_rm == item.no_rm;
          });
          this.rows3 = this.rows3.map((item) => {
            // item.masuk=item.formatted_tgl_masuk+" "+item.formatted_jam_masuk;
            // item.keluar=item.formatted_tgl_keluar+" "+item.formatted_jam_keluar;
            return item;
          });
          //console.log(this.rows3);
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
        this.print();
      }
    },
    displayOptik: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        let params = `?per_page=999999999999&no_rm=${no_rm}&orderBy=desc`;
        let result = await this.$store.state.HTTP.get(`menu/optik${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows4 = result.data.filter((item) => {
            return no_rm == item.no_rm;
          });
          this.rows4 = this.rows4.map((item) => {
            // item.masuk=item.formatted_tgl_masuk+" "+item.formatted_jam_masuk;
            // item.keluar=item.formatted_tgl_keluar+" "+item.formatted_jam_keluar;
            return item;
          });
          //console.log(this.rows4);
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
        this.print();
      }
    },
    displayLab: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        let params = `?per_page=999999999999&no_rm=${no_rm}&orderBy=desc`;
        let result = await this.$store.state.HTTP.get(`menu/lab${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows5 = result.data.filter((item) => {
            return no_rm == item.no_rm;
          });
          this.rows5 = this.rows5.map((item) => {
            // item.masuk=item.formatted_tgl_masuk+" "+item.formatted_jam_masuk;
            // item.keluar=item.formatted_tgl_keluar+" "+item.formatted_jam_keluar;
            return item;
          });
          //console.log(this.rows5);
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
        this.print();
      }
    },
    displayOperasi: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        //let params=`?per_page=999999999999&no_rm=${no_rm}&orderBy=desc`;
        //console.log(params);
        let result = await this.$store.state.HTTP.get(`operasi`);
        // let result = await this.$store.state.HTTP.get(`operasi${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows6 = result.data.data.filter((item) => {
            return no_rm == item.ralan.no_rm;
          });
          this.rows6 = this.rows6.map((item) => {
            // item.masuk=item.formatted_tgl_masuk+" "+item.formatted_jam_masuk;
            // item.keluar=item.formatted_tgl_keluar+" "+item.formatted_jam_keluar;
            return item;
          });
          //console.log(this.rows6);
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
      }
    },
    displayUgd: async function(no_rm) {
      // this.loaded=false;
      this.errors = [];
      try {
        let params = `?per_page=999999999999&darurat=1&no_rm=${no_rm}&orderBy=desc`;
        let result = await this.$store.state.HTTP.get(`ralan${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows7 = result.data.data.filter((item) => {
            return no_rm == item.no_rm;
          });
          this.rows7 = this.rows7.map((item) => {
            // item.masuk=item.formatted_tgl_masuk+" "+item.formatted_jam_masuk;
            // item.keluar=item.formatted_tgl_keluar+" "+item.formatted_jam_keluar;
            return item;
          });
          //console.log(this.rows7);
          // this.loaded=true;
        } else {
          this.errors.push(result.status);
          // this.loaded=true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        // this.loaded=true;
      }
      this.nDisplay -= 1;
      if (!this.nDisplay || this.nDisplay <= 0) {
        this.loaded = true;
        this.print();
      }
    },
    print: async function() {
      setTimeout(function() {
        window.print();
      }, 300);
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.displayData();
  },
};
</script>
